import styles from './ActionCardLayout.module.scss'
import cn from 'classnames'

function ActionCardLayoutRoot({ className, children, ...props }) {
  return (
    <div
      className={cn(styles['root'], { [className]: className })}
      {...props}
    >
      {children}
    </div>
  )
}

function MainRoot({ className, children, ...props }) {
  return (
    <div
      className={cn(styles['main'], { [className]: className })}
      {...props}
    >
      {children}
    </div>
  )
}

function FooterRoot({ className, children, ...props }) {
  return (
    <div
      className={cn(styles['footer'], { [className]: className })}
      {...props}
    >
      {children}
    </div>
  )
}

const ActionCardLayout = Object.assign(ActionCardLayoutRoot, { Main: MainRoot, Footer: FooterRoot })

export default ActionCardLayout
